import styled from 'styled-components';

export const TitleBadge = styled.span`
  padding: 0.2rem 1rem;
  border-radius: 4px;
  text-transform: capitalize;
  background-color: ${props => {
    switch (props.value) {
      case 'yes':
        return '#28A744';
      case 'no':
        return '#DC3445';
      default:
        return '#FFC105';
    }
  }};
  color: ${props => {
    switch (props.value) {
      case 'yes':
        return '#FFF !important';
      case 'no':
        return '#FFF !important';
      default:
        return '#fff !important';
    }
  }};
`;
export const StatusBadge = styled.span`
  padding: 0.2rem 1rem;
  border-radius: 4px;
  text-transform: capitalize;
  background-color: ${props => {
    switch (props.value) {
      case 'available':
        return '#28A744';
      case 'subscribed':
        return '#DC3445';
      default:
        return '#FFC105';
    }
  }};
  color: ${props => {
    switch (props.value) {
      case 'available':
        return '#FFF !important';
      case 'subscribed':
        return '#FFF !important';
      default:
        return '#fff !important';
    }
  }};
`;
